import { SettingsAPI } from '@weave/schema-gen-ts/dist/schemas/reviews/v1/settings/settings_api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSettingsV1Service = bindHTTP(SettingsAPI);
